import React from "react";
import { Query, Mutation } from "react-apollo";
import { Message } from "semantic-ui-react";
import { Trans } from "react-i18next";

import Registrations from "./Registrations";
import Spinner from "../../../spinner/Spinner";
import registrationsQuery from "../../../../gql/registrationsQuery";
import confirmAttendanceMutation from "../../../../gql/confirmAttendanceMutation";
import disconfirmAttendanceMutation from "../../../../gql/disconfirmAttendanceMutation";

import { toastTranslated } from "../../../../toastr/toastr";

function RegistrationsContainer({ trainingUnit, onUpdateTrainingUnit }) {
  const refreshTrainingUnit = refetch => () => {
    refetch();

    onUpdateTrainingUnit();
  };

  const handleConfirmAttendance = mutateFunc => ({
    trainingUnit,
    registration
  }) => {
    mutateFunc({
      variables: {
        input: {
          trainingUnitId: trainingUnit.id,
          memberId: registration.member.id
        }
      },
      refetchQueries: [
        {
          query: registrationsQuery,
          variables: {
            filter: {
              trainingUnitId: trainingUnit.id
            }
          }
        }
      ]
    }).then(() => {
      toastTranslated("success", "members.events.confirmAttendance");
    });
  };

  const handleDisconfirmAttendance = mutateFunc => ({
    trainingUnit,
    registration
  }) => {
    mutateFunc({
      variables: {
        input: {
          trainingUnitId: trainingUnit.id,
          memberId: registration.member.id
        }
      },
      refetchQueries: [
        {
          query: registrationsQuery,
          variables: {
            filter: {
              trainingUnitId: trainingUnit.id
            }
          }
        }
      ]
    }).then(() => {
      toastTranslated("success", "members.events.disconfirmAttendance");
    });
  };

  const getRegistrationList = registrations => {
    const sorted = [...registrations].sort((a, b) => {
      return a.registrationDate > b.registrationDate ? 1 : -1;
    });

    return sorted
      .filter(r => !r.canceled)
      .slice(0, trainingUnit.courseDate.maximumParticipants);
  };

  const getWaitingList = registrations => {
    const sorted = [...registrations].sort((a, b) => {
      return a.registrationDate > b.registrationDate ? 1 : -1;
    });

    return sorted
      .filter(r => !r.canceled)
      .slice(trainingUnit.courseDate.maximumParticipants);
  };

  const getCanceledList = registrations => {
    const sorted = [...registrations].sort((a, b) => {
      return a.registrationDate > b.registrationDate ? 1 : -1;
    });

    return sorted.filter(r => r.canceled);
  };

  return (
    <Mutation mutation={confirmAttendanceMutation}>
      {confirmMutateFunc => (
        <Mutation mutation={disconfirmAttendanceMutation}>
          {disconfirmMutateFunc => (
            <Query
              query={registrationsQuery}
              fetchPolicy="cache-and-network"
              variables={{ filter: { trainingUnitId: trainingUnit.id } }}
            >
              {({ loading, error, data, refetch }) => {
                if (loading) return <Spinner />;
                if (error) {
                  return (
                    <Message
                      error
                      content={<Trans i18nKey="errors.noData" />}
                    />
                  );
                }

                var { registrations } = data;

                return (
                  <Registrations
                    trainingUnit={trainingUnit}
                    registrations={registrations}
                    registrationList={getRegistrationList(registrations)}
                    waitingList={getWaitingList(registrations)}
                    canceledList={getCanceledList(registrations)}
                    handleRefresh={refreshTrainingUnit(refetch)}
                    handleConfirmAttendance={handleConfirmAttendance(
                      confirmMutateFunc
                    )}
                    handleDisconfirmAttendance={handleDisconfirmAttendance(
                      disconfirmMutateFunc
                    )}
                  />
                );
              }}
            </Query>
          )}
        </Mutation>
      )}
    </Mutation>
  );
}

RegistrationsContainer.displayName =
  "coursePlan/details/registrations/RegistrationsContainer";

export default React.memo(RegistrationsContainer);
